import { forwardRef } from 'react';
import React from 'react';
import 'react-phone-number-input/style.css';
import './index.css';
import { InputBase, styled } from '@mui/material';
// import { parsePhoneNumber } from 'libphonenumber-js';

const PhoneInputBase = styled(InputBase)(({ theme }) => ({
  position: 'relative',
  padding: '0px 0px',
  margin: '0px 0px 0px 8px',
  '& .MuiInputBase-input': {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    padding: 0,
  },
}));

const PlaceholderWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}));

const PlaceholderText = styled('span')(({ theme, hasValue }) => ({
  position: 'absolute',
  left: theme?.direction === "ltr" ? 60 : "unset",
  right: theme?.direction === "rtl" ? 60 : "unset",
  color: hasValue ? 'transparent' : '#D0D5DD', // Hide placeholder when there is text
  pointerEvents: 'none',
  transition: 'color 0.2s',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
}));

const MapitPhoneInputComponent = (props, ref) => {

  // const isValueEntered = (value) => {
  //   try {
  //     const parsedPhone = parsePhoneNumber(value, { extract: true })
  //     const phone = parsedPhone.nationalNumber;
  //     return !!phone
  //   } catch (e) {
  //     return false;
  //   }
  // };

  return (
    <PlaceholderWrapper>
      <PlaceholderText hasValue={props?.value?.length > 4}>{props?.placeholder}</PlaceholderText>
      <PhoneInputBase
        {...props}
        inputRef={ref}
        fullWidth
        size='small'
        variant='outlined'
        name='phone'
      />
    </PlaceholderWrapper>
  );
};

export default forwardRef(MapitPhoneInputComponent);